import { ReactNode } from 'react';
import { Header } from '@tanstack/react-table';
import { SortIcon } from 'assets/icons';
import classNames from 'classnames';

import styles from './Sorting.module.scss';

export const Sorting = ({
    header,
    children,
    className,
}: {
    header: Header<any, unknown>;
    children: ReactNode;
    className?: string;
}) => {
    if (header.isPlaceholder || !header.column.getCanSort()) {
        return <div className={classNames(styles.placeholder, className)}>{children}</div>;
    }

    const sortDirection = header.column.getIsSorted();

    const handleChangeSortingDirection = () => {
        const next = {
            asc: true,
            desc: undefined,
            false: false,
        };
        const currentSorting = header.column.getIsSorted();
        if (next[currentSorting.toString() as keyof typeof next] === undefined) header.column.clearSorting();
        else header.column.toggleSorting(next[currentSorting.toString() as keyof typeof next]);
    };

    return (
        <button
            className={classNames(styles['sort-button'], className)}
            type="button"
            onClick={handleChangeSortingDirection}
        >
            {children}
            <SortIcon data-direction={sortDirection} className={styles.sortIcon} height={16} width={16} />
        </button>
    );
};
